import * as React from 'react';

import {cx} from '../util';

export const Spinner = ({className}) => {
  const classes = cx('animate-spin w-10 h-10 border-8 border-gray-300 border-r-transparent rounded-full inline-block', className);
  return <div className={classes} />;
};

export const SpinnerPage = ({className}) => (
  <div className={cx('flex justify-center p-16 min-h-screen', className)}>
    <Spinner />
  </div>
);
